<template>
  <div class="m-4">
    <filters
      v-model="filtersValue"
      @on-filter="changeFilter"
    ></filters>
    <div class="row">
      <div class="col-xl-6 col-12">
        <chart-line
          ref="chartLine"
          :columns="columns"
          :data="dataChart"
          :labels="labels"
          :options="options"
        ></chart-line>
      </div>
      <div class="col-xl-6 col-12">
        <grid ref="grid" :config="gridConfig" :prepareGet="prepareGridData"/>
      </div>
    </div>
  </div>
</template>
<script>
import gridConfig from './GridConfig'
import { waitValue } from '@/utils/promises'
import { filterOrigin } from '@/utils/arrays'
import { getMonthLabels, getMonthLabelByID } from '@/utils/months'
import { api } from '@/services/api'

export default {
  name: 'Reports',
  components: {
    'chart-line': () => import(/* webpackChunkName: 'Chart' */ '@/components/Chart/Bar'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'filters': () => import(/* webpackChunkName: 'QuickRFQ2' */ './Filters')
  },
  props: {
    moduleName: { type: String, required: true }
  },
  mounted () {
    return Promise.all([
      this.LoadDataChart(),
      this.loadDataGrid()
    ])
  },
  data () {
    return {
      gridConfig: gridConfig,
      filtersValue: {
        year: new Date().getFullYear()
      },
      filters: [
        {
          field: 'year',
          // eslint-disable-next-line
          template: 'yearMonth/100 == ${data.value}'
        }
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            offset: true
          }]
        }
      },
      labels: getMonthLabels(this.L10n),
      dataChart: [],
      columns: [
        {
          label: this.L10n('total-parts'), key: 'total-parts'
        },
        {
          label: this.L10n('total-suppliers'), key: 'total-suppliers'
        }
      ]
    }
  },
  computed: {
    isHighPermission () {
      return this.$store.getters.isHighPermission
    },
    employeeID () {
      return this.$store.state[this.moduleName].formDataRFQ2.employeeID
    },
    queryOptionFilter () {
      let toolFilters = this.filters
        .filter(({ field }) => !!this.filtersValue[field])
        // eslint-disable-next-line
        .map(({ field, template = '${data.field}==${data.value}' }) => {
          return this.checkEs6AndRun(template, { field: field, value: this.filtersValue[field], data: this.filtersValue })
        })
        .filter((filterStr) => filterStr)
      toolFilters = toolFilters.length
        ? `&${toolFilters.join(' && ')}`
        : ''
      return `employeeID == ${this.employeeID}${toolFilters}`
    }
  },
  methods: {
    prepareGridData (data) {
      return data.map((item) => {
        return { ...item, month: getMonthLabelByID(item.month) }
      })
    },
    changeFilter () {
      this.LoadDataChart()
      this.loadDataGrid()
    },
    getChart () {
      return waitValue(() => this.$refs.chartLine)
    },
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    loadDataGrid () {
      this.getGrid()
        .then(grid => {
          grid.model.store.get.filters = this.queryOptionFilter
          grid.loadData()
        })
    },
    /**
     * @desc Load data for chart
     * @returns {AxiosPromise<any>}
     */
    LoadDataChart () {
      const params = {
        'select': 'yearMonth.toString().Substring(0,4) as year, yearMonth.toString().Substring(4,2) as month,employeeID,employeeName,totalSuppliers,totalParts',
        'filter': this.queryOptionFilter
      }
      return api.get(`Statistics/GetAllStatisticsEmployeePerformanceRFQ2`, { params })
        .then((response) => {
          const dataSuppliers = response.data.value.map(({ month, totalSuppliers }) => {
            return {
              x: getMonthLabelByID(month),
              y: totalSuppliers,
              columnKey: 'total-suppliers'
            }
          })
          const dataParts = response.data.value.map(({ month, totalParts }) => {
            return {
              x: getMonthLabelByID(month),
              y: totalParts,
              columnKey: 'total-parts'
            }
          })
          this.dataChart = filterOrigin(dataSuppliers.concat(dataParts))
        })
        .then(() => {
          this.getChart()
            .then((chart) => {
              chart.render()
            })
        })
    }
  }
}
</script>
